import React, { forwardRef, useRef } from 'react';
import { ReactThreeFiber, extend, useThree, useFrame, Overwrite } from 'react-three-fiber';
import LookControlsImpl from '../../../common/three/look-controls';
import mergeRefs from 'react-merge-refs';

extend({ LookControlsImpl });

export type TLookControls = Overwrite<ReactThreeFiber.Object3DNode<LookControlsImpl, typeof LookControlsImpl>, {}>;

declare global {
  namespace JSX {
    interface IntrinsicElements {
      lookControlsImpl: TLookControls;
    }
  }
}

const LookControls = forwardRef((props: TLookControls, ref) => {
  const controls = useRef<LookControlsImpl>();
  const { camera, gl /* , invalidate  */ } = useThree();

  useFrame(() => controls.current?.tick());

  // useEffect(() => {
  //   const current = controls.current;
  //   current?.addEventListener('change', invalidate);
  //   return () => current?.removeEventListener('change', invalidate);
  // }, [invalidate]);

  const object3D = camera.parent;

  if (!object3D) {
    return null;
  }

  return <lookControlsImpl ref={mergeRefs([controls, ref])} args={[object3D, gl.domElement]} {...props} />;
});

export default LookControls;
